define.alias("shared/components/shared/post/secondary/toggle", "calendar/components/shared/post/secondary/toggle");